import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilderBase } from '../../../core/models/form-builder/form-builder-base';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {

  @Input() config: FormBuilderBase<string>;
  @Input() form: FormGroup;
  get isInValid(): boolean {
    if (this.form) {
      const c = this.form.get(this.config.key);
      return c.invalid && (c.touched || c.dirty);
    }
    return false;
  }
  constructor() { }

  ngOnInit(): void {
  }

}
